module.exports = {
  SharedTypes: {
    PUBLIC: 'PUBLIC',
    DISTRICT: 'DISTRICT',
    INDIVIDUAL: 'INDIVIDUAL',
  },
}
